import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Sinu tootega sobivad kokku järgmised tooted:

  <span style="color:#85c1dc;">**FI:**</span>
  Seuraavat tuotteet ovat yhteensopivia tuotteesi kanssa:

  <span style="color:#85c1dc;">**RU:**</span>
  Следующие продукты совместимы с Вашим продуктом:
*/
/* @__NO_SIDE_EFFECTS__ */
const m195 = msg(
  mf`Sinu tootega sobivad kokku järgmised tooted:`,
  mf`Seuraavat tuotteet ovat yhteensopivia tuotteesi kanssa:`,
  mf`Следующие продукты совместимы с Вашим продуктом:`,
)

export { m195 as 'w.module.product_modal.similar_products' }